<!--
 * @Description: 运维服务监测Top
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-25 14:19:02
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-20 13:18:25
 -->
<template>
  <div class="maintenance-top">
    <div class="totalMileage">
      累计服务道路里程：<span class="value">{{data.mileageTotal}}</span>公里
    </div>
    <div class="protectDays">
      安全守护<span class="protectDaysValueItem" v-for="(item, index) in data.guardDays" :key="index">{{item}}</span>天
    </div>
    <div class="newAddMileage">
      <div class="mileage">{{month}}月新增里程数：<span class="value">{{data.mileageMonth}}</span> 公里</div>
      <div class="compare">
        <div class="item">
          同比 <span :class="data.yearOnYear >= 0 ? 'el-icon-top' : 'el-icon-bottom'"></span> {{data.yearOnYear}}%
        </div>
        <div class="item">
          环比 <span :class="data.monthOnMonth >= 0 ? 'el-icon-top' : 'el-icon-bottom'"></span> {{data.monthOnMonth}}%
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'maintenanceTop',
  components: {
  },
  data () {
    return {
      data: {},
      month: new Date().getMonth() + 1
    }
  },
  methods: {
    /**
     * @description                   获取汇总数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/operation/top/summary')
        .then(res => {
          if (res.code === 0) {
            this.data = res.data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  created () {
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  .maintenance-top {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    >div {
      width: 33%;
      text-align: center;
    }
    .totalMileage {
      font-size: 1.6vh;
      color: #00fcf0;
      .value {
        font-size: 2.3vh;
        font-weight: bold;
        color: #e4ee0c;
      }
    }
    .protectDays {
      font-size: 3vh;
      color: #fff;
      width: 30%;
      .protectDaysValueItem {
        display: inline-block;
        font-size: 3.2vh;
        background: #108484;
        border: solid 1px #1f99bb;
        width: 5%;
        text-align: center;
        margin: 0 1%;
        padding: 1% 0.5%;
      }
    }
    .newAddMileage {
      .mileage {
        font-size: 1.6vh;
        color: #00fcf0;
        margin-bottom: 1vh;
        .value {
          font-size: 2.3vh;
          font-weight: bold;
        }
      }
      .compare {
        .item {
          display: inline-block;
          font-size: 1.4vh;
          color: #fff;
          margin-right: 2%;
          .el-icon-top {
            color: #d92626;
            font-weight: bold;
            font-size: 1.8vh;
          }
          .el-icon-bottom {
            color: #16c840;
            font-weight: bold;
            font-size: 1.8vh;
          }
        }
      }
    }
  }
</style>
